export const financeHotspots = [
  {
    id: 'f1',
    title: '央行释放流动性宽松信号，市场关注后续政策节奏',
    summary: '央行在最新会议纪要中提出将视经济恢复情况灵活调整货币政策工具，多家机构解读为偏宽松信号。',
    source: '中国证券报',
    publishTime: '2026-08-03 09:30',
    updateTime: '2026-08-03 11:15',
    tags: ['宏观政策', '央行'],
    heat: '高',
    impactDirection: '宏观',
    content: '中国人民银行在最新发布的货币政策委员会会议纪要中指出，将继续实施稳健的货币政策，同时强调将根据国内外经济金融形势变化，灵活适度运用多种货币政策工具，保持流动性合理充裕。\n\n多位市场分析人士认为，这一表述较此前更为积极，可能预示着未来一段时间货币政策将维持偏宽松基调。华泰证券宏观团队指出，在当前经济恢复基础尚不牢固的背景下，政策信号有助于稳定市场预期。\n\n不过也有声音提醒，当前需要关注海外主要央行的政策路径，以及国内通胀形势的变化。',
    keyPoints: [
      '央行会议纪要提出灵活调整货币政策工具',
      '多家机构解读为偏宽松信号',
      '市场关注后续降准或结构性工具可能性',
      '海外央行政策路径是重要外部变量',
    ],
    whyImportant: '货币政策方向直接影响市场流动性和资产定价。本次信号释放可能为下半年A股和债市提供更友好的资金环境，值得持续跟踪后续具体操作。',
    relatedIds: ['f4', 'f6'],
  },
  {
    id: 'f2',
    title: '科技板块集体走强，AI应用端商业化进展超预期',
    summary: '多家AI应用公司公布二季度财报，营收和用户增长均超市场预期，带动科技板块情绪回暖。',
    source: '证券时报',
    publishTime: '2026-08-03 10:15',
    updateTime: '2026-08-03 10:15',
    tags: ['科技与AI', 'AI应用'],
    heat: '高',
    impactDirection: '科技',
    content: '随着二季度财报季进入高峰期，多家AI应用领域的上市公司交出了超出市场预期的成绩单。\n\n科大讯飞、商汤科技等头部企业均实现了AI相关业务的快速增长，特别是在教育、办公、医疗等垂直场景的商业化落地加速。海外方面，微软、谷歌等巨头的AI云服务收入也保持强劲增长态势。\n\n分析人士指出，AI行业正在从"讲故事"阶段进入"兑现业绩"阶段，能够真正实现商业闭环的公司将获得更多市场认可。不过也需要注意估值水平和竞争格局的变化。',
    keyPoints: [
      '多家AI应用公司二季度业绩超预期',
      '教育、办公、医疗等场景商业化加速',
      '海外科技巨头AI云服务增长强劲',
      '行业从概念阶段进入业绩兑现期',
    ],
    whyImportant: 'AI应用端的商业化进展是判断AI行业能否持续发展的关键指标。如果更多公司能够证明AI能够带来实际收入增长，可能带动整个科技板块的估值重估。',
    relatedIds: ['f1', 'f8'],
  },
  {
    id: 'f3',
    title: '新能源产业链预期改善，上游材料价格企稳回升',
    summary: '锂、钴等新能源上游材料价格在连续调整后出现企稳迹象，部分品种小幅反弹，市场关注下游需求恢复情况。',
    source: '经济观察报',
    publishTime: '2026-08-03 08:45',
    updateTime: '2026-08-03 09:00',
    tags: ['新能源', '产业链'],
    heat: '中',
    impactDirection: '新能源',
    content: '在经过近半年的持续调整后，新能源产业链上游材料价格近期出现企稳迹象。电池级碳酸锂价格稳定在每吨18万元左右，部分中小型材料企业开始试探性提价。\n\n业内人士表示，价格企稳主要受到三方面因素支撑：一是下游电池厂商去库存接近尾声，开始恢复采购；二是海外锂矿供给增速低于预期；三是新能源汽车销量在补贴政策刺激下维持较高增速。\n\n不过，市场对价格回升的持续性仍持谨慎态度，认为需要观察下半年实际需求能否持续改善。',
    keyPoints: [
      '锂钴等上游材料价格出现企稳迹象',
      '下游去库存接近尾声，采购需求回暖',
      '新能源汽车销量维持较高增速',
      '市场对价格回升持续性仍存分歧',
    ],
    whyImportant: '新能源产业链上游价格企稳，可能预示着行业供需格局正在改善。如果这一趋势得到确认，相关上市公司盈利预期有望上修。',
    relatedIds: ['f7'],
  },
  {
    id: 'f4',
    title: '美联储7月会议纪要：多数官员支持维持利率不变',
    summary: '美联储公布的7月会议纪要显示，绝大多数与会官员认为当前利率水平适当，但将继续评估经济数据以决定下一步行动。',
    source: '财经网',
    publishTime: '2026-08-03 07:00',
    updateTime: '2026-08-03 08:30',
    tags: ['港股与美股', '宏观政策'],
    heat: '高',
    impactDirection: '宏观',
    content: '美联储公布的7月联邦公开市场委员会会议纪要显示，绝大多数与会官员认为当前的联邦基金利率水平是适当的。\n\n纪要指出，与会者普遍认为需要更多证据来确认通胀正持续向2%目标回落，才会考虑调整政策立场。同时，多位官员也表达了对劳动力市场过快降温的担忧。\n\n市场对此反应平淡，美股三大指数小幅波动。分析人士认为，市场已经充分定价了利率维持不变的预期，更需要关注的是后续经济数据尤其是非农就业和CPI数据。',
    keyPoints: [
      '美联储7月纪要显示多数官员支持维持利率不变',
      '需要更多通胀回落证据才考虑调整政策',
      '部分官员对劳动力市场降温表达担忧',
      '市场更关注后续经济数据',
    ],
    whyImportant: '全球最重要的央行政策信号，直接关系到全球资产定价锚——美债收益率的走向，进而影响全球股市、汇市和商品市场。',
    relatedIds: ['f1', 'f6'],
  },
  {
    id: 'f5',
    title: '多地出台消费刺激政策，汽车家电以旧换新力度加大',
    summary: '多个省市在8月初集中发布新一轮消费刺激方案，重点覆盖新能源汽车、绿色家电、文旅消费等领域。',
    source: '人民日报',
    publishTime: '2026-08-03 06:30',
    updateTime: '2026-08-03 06:30',
    tags: ['消费', '政策'],
    heat: '中',
    impactDirection: '消费',
    content: '进入8月，北京、上海、广东、浙江等多个省市密集发布新一轮消费促进政策。其中，新能源汽车以旧换新补贴标准进一步提高，部分车型综合补贴可达3万元。\n\n在家电领域，绿色节能产品成为本轮补贴重点，一级能效空调、冰箱等产品可享受额外15%-20%的价格补贴。此外，多地还推出了文旅消费券，鼓励暑期和国庆黄金周出行消费。\n\n专家表示，消费刺激政策具有明显的季节性特征，预计下半年社零增速将在政策助力下维持稳中有升的态势。',
    keyPoints: [
      '多省市8月集中发布消费刺激政策',
      '新能源汽车以旧换新补贴力度加大',
      '绿色家电享受额外价格补贴',
      '下半年消费有望维持稳中有升',
    ],
    whyImportant: '消费是经济增长的核心驱动力之一。政策密集出台时期，往往对应着消费板块的投资窗口期，相关上市公司有望受益于需求提振。',
    relatedIds: ['f3'],
  },
  {
    id: 'f6',
    title: 'A股成交额重回万亿，北向资金连续三日净流入',
    summary: '在政策预期和外部环境改善的推动下，A股市场活跃度显著提升，北向资金阶段性地回流。',
    source: '上海证券报',
    publishTime: '2026-08-03 15:30',
    updateTime: '2026-08-03 16:00',
    tags: ['A股', '资金流向'],
    heat: '中',
    impactDirection: 'A股',
    content: 'A股市场今日成交额再度突破万亿元大关，为近两周来首次。三大指数全线收涨，其中创业板指涨幅领先。\n\n北向资金今日净流入约45亿元，为连续第三个交易日净流入。从行业分布看，资金主要流向新能源、消费电子和医药板块。\n\n市场分析认为，成交回暖主要受到央行政策信号和海外流动性预期改善的双重推动。不过，目前仍处于存量博弈格局，需要观察成交放量能否持续。',
    keyPoints: [
      'A股成交额重回万亿元',
      '北向资金连续三日净流入',
      '资金主要流向新能源、消费电子和医药',
      '成交回暖受政策和外部环境双重推动',
    ],
    whyImportant: '成交额是衡量市场活跃度的核心指标，万亿成交通常被视为市场情绪回暖的重要信号。北向资金的持续性也反映了外资对中国资产的短期态度。',
    relatedIds: ['f1', 'f4'],
  },
  {
    id: 'f7',
    title: '某新能源车企发布新一代固态电池技术路线图',
    summary: '头部新能源车企在技术发布会上展示了固态电池研发进展，预计2028年实现量产装车。',
    source: '澎湃新闻',
    publishTime: '2026-08-02 16:00',
    updateTime: '2026-08-03 09:00',
    tags: ['新能源', '科技与AI', '公司动态'],
    heat: '高',
    impactDirection: '科技',
    content: '某头部新能源车企今日举办技术发布会，详细展示了其固态电池研发的最新进展。\n\n根据发布的技术路线图，该公司计划在2026年底完成固态电池A样测试，2027年进入B样阶段，目标在2028年实现量产装车。公司表示，新一代固态电池能量密度将达到400Wh/kg，较当前液态锂电池提升约40%。\n\n固态电池被视为下一代动力电池的核心方向，具有更高的能量密度和安全性。多家机构认为，如果公司技术路线图如期推进，将对其长期竞争力产生积极影响。但同时也需注意，固态电池从实验室到量产的路径仍面临成本、良率等挑战。',
    keyPoints: [
      '头部车企发布固态电池技术路线图',
      '目标2028年实现量产，能量密度达400Wh/kg',
      '固态电池是下一代动力电池核心方向',
      '量产仍面临成本和良率挑战',
    ],
    whyImportant: '固态电池技术突破是新能源产业链最受关注的技术变量之一。如果能够按计划推进，将重塑动力电池和新能源汽车行业的竞争格局。',
    relatedIds: ['f3', 'f8'],
  },
  {
    id: 'f8',
    title: '科技巨头加码自研芯片，AI算力竞赛进入新阶段',
    summary: '多家科技巨头披露自研AI芯片计划，从云端到端侧的全场景算力布局正在加速形成。',
    source: '36氪',
    publishTime: '2026-08-02 14:00',
    updateTime: '2026-08-03 10:00',
    tags: ['科技与AI', '公司动态', '港股与美股'],
    heat: '中',
    impactDirection: '科技',
    content: '近期，多家全球科技巨头密集披露了自研AI芯片的最新进展。\n\n海外方面，亚马逊、谷歌、微软均加大了对自研训练和推理芯片的投入，试图降低对英伟达的依赖。国内方面，百度、字节跳动、华为也在积极推进自研AI芯片的布局。\n\n行业分析师指出，AI芯片自研化趋势将对整个半导体产业链产生深远影响。短期来看，英伟达的领先地位仍然稳固；但中长期视角下，定制化芯片的崛起可能改变市场格局。同时，这也为芯片设计服务和先进封装领域带来了新的增长机会。',
    keyPoints: [
      '全球科技巨头密集推进自研AI芯片',
      '从云端到端侧的全场景布局加速',
      '短期英伟达地位稳固，中长期格局可能变化',
      '芯片设计和先进封装将受益',
    ],
    whyImportant: 'AI芯片是AI产业的基础设施，自研芯片趋势不仅影响科技巨头之间的竞争格局，还将重塑整个半导体供应链，是观察科技行业长期走向的重要窗口。',
    relatedIds: ['f2', 'f7'],
  },
  {
    id: 'f9',
    title: '港股恒生科技指数连续反弹，互联网板块情绪修复',
    summary: '恒生科技指数近一周累计涨幅超8%，互联网龙头公司二季度业绩普遍超出预期。',
    source: '香港经济日报',
    publishTime: '2026-08-03 16:30',
    updateTime: '2026-08-03 16:30',
    tags: ['港股与美股', '科技与AI'],
    heat: '中',
    impactDirection: '港股',
    content: '恒生科技指数今日继续走高，近一周累计涨幅已超过8%，为近三个月来最大单周涨幅。\n\n推动本轮反弹的主要因素包括：互联网龙头二季度业绩普遍超预期、回购力度加大、以及估值处于历史低位带来的修复动力。腾讯、阿里巴巴、美团等权重股均录得显著涨幅。\n\n不过，分析人士提醒，港股反弹的持续性仍需观察南向资金流向和国际地缘政治环境的变化。短期来看，市场情绪确实在改善，但不宜过度乐观。',
    keyPoints: [
      '恒生科技指数近一周涨超8%',
      '互联网龙头二季度业绩普遍超预期',
      '回购力度加大叠加估值修复',
      '反弹持续性仍需观察资金面和外部环境',
    ],
    whyImportant: '港股互联网板块是观察中国科技行业乃至整体经济信心的重要窗口。本轮反弹能否持续，将影响市场对中概股和港股的整体情绪。',
    relatedIds: ['f2', 'f4'],
  },
  {
    id: 'f10',
    title: '消费电子供应链库存趋于健康，三季度备货旺季启动',
    summary: '消费电子产业链库存水平已回落至正常区间，多家代工厂和零部件供应商表示三季度订单回暖。',
    source: '第一财经',
    publishTime: '2026-08-02 10:00',
    updateTime: '2026-08-03 08:00',
    tags: ['消费', '公司动态', 'A股'],
    heat: '低',
    impactDirection: '消费',
    content: '据多家供应链调研机构最新报告，消费电子产业链的库存水平经过近一年的去化，已基本回落至正常区间。\n\n台湾主要代工厂和大陆零部件供应商均表示，三季度订单量环比有所改善，尤其是手机和PC相关订单回暖较为明显。部分企业开始为下半年的新品发布季提前备货。\n\n不过，终端需求恢复的力度仍存在不确定性。市场研究机构IDC认为，2026年全球智能手机出货量预计同比仅增长3%-5%，属于温和修复而非强劲反弹。',
    keyPoints: [
      '消费电子产业链库存回落至正常水平',
      '三季度备货旺季订单环比改善',
      '手机和PC相关订单回暖明显',
      '终端需求预计温和修复而非强劲反弹',
    ],
    whyImportant: '消费电子是全球最大的科技消费市场之一。库存恢复健康意味着最困难的去库存阶段可能已经过去，对相关上市公司业绩构成边际利好。',
    relatedIds: ['f5'],
  },
];

export const financeTimeline = [
  { time: '16:30', title: '港股恒生科技指数连续反弹，互联网板块情绪修复', id: 'f9', heat: '中' },
  { time: '15:30', title: 'A股成交额重回万亿，北向资金连续三日净流入', id: 'f6', heat: '中' },
  { time: '11:15', title: '央行释放流动性宽松信号，市场关注后续政策节奏（更新）', id: 'f1', heat: '高' },
  { time: '10:15', title: '科技板块集体走强，AI应用端商业化进展超预期', id: 'f2', heat: '高' },
  { time: '09:30', title: '央行释放流动性宽松信号，市场关注后续政策节奏', id: 'f1', heat: '高' },
  { time: '08:45', title: '新能源产业链预期改善，上游材料价格企稳回升', id: 'f3', heat: '中' },
  { time: '07:00', title: '美联储7月会议纪要：多数官员支持维持利率不变', id: 'f4', heat: '高' },
  { time: '06:30', title: '多地出台消费刺激政策，汽车家电以旧换新力度加大', id: 'f5', heat: '中' },
];

export type FinanceHotspot = typeof financeHotspots[number];
export type FinanceTimelineItem = typeof financeTimeline[number];